var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-317.487 -296.487)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(317 296)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(0.487 0.487)",
    fill: "#ffde17"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.228,7.83H1.958a.28.28,0,0,0-.28.28v.559a.28.28,0,0,0,.28.28H9.228a.28.28,0,0,0,.28-.28V8.11A.28.28,0,0,0,9.228,7.83Zm1.119-5.593a.839.839,0,0,0-.839.839.82.82,0,0,0,.077.346L8.32,4.181a.559.559,0,0,1-.772-.2L6.122,1.486a.839.839,0,1,0-1.059,0L3.639,3.978a.559.559,0,0,1-.772.2L1.6,3.422a.839.839,0,1,0-.764.493A.874.874,0,0,0,.973,3.9l1.264,3.37H8.949L10.212,3.9a.838.838,0,1,0,.135-1.664Z",
    transform: "translate(321.894 301.593)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.983d7e60adec743e7c374e9a246a6475.svg";
export { ForwardRef as ReactComponent };